import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ZapIcon, ShieldCheckIcon } from 'lucide-react';
export function ProductIntro() {
  return <section className="py-14 bg-brand-darker relative border-t border-zinc-900" data-id="element-334">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(6,182,212,0.05)_0%,transparent_70%)]" data-id="element-335"></div>

      <div className="container mx-auto px-4 max-w-5xl text-center relative z-10" data-id="element-336">
        <FadeIn data-id="element-337">
          <div className="inline-flex items-center justify-center gap-2 mb-6" data-id="element-338">
            <ZapIcon className="w-6 h-6 text-brand-cyan" data-id="element-339" />
            <span className="text-brand-cyan font-bold tracking-widest uppercase" data-id="element-340">
              Presentamos
            </span>
            <ZapIcon className="w-6 h-6 text-brand-cyan" data-id="element-341" />
          </div>

          <h2 className="text-5xl md:text-7xl font-bold text-white mb-4 text-glow-cyan" data-id="element-342">
            MASTER PACK:
            <br className="hidden md:block" data-id="element-343" /> REPARACIÓN EXPRESS
          </h2>

          <p className="text-2xl md:text-3xl text-zinc-300 font-heading tracking-wide mb-8" data-id="element-344">
            El Sistema de los 5 Protocolos
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-345">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-zinc-900 border border-brand-cyan/30 rounded-full mb-10 shadow-[0_0_20px_rgba(6,182,212,0.1)]" data-id="element-346">
            <ShieldCheckIcon className="w-5 h-5 text-brand-cyan" data-id="element-347" />
            <span className="text-white font-bold tracking-wide" data-id="element-348">
              Pack 5 Tomos + 2 Bonos
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-349">
          <div className="grid md:grid-cols-2 gap-12 text-left max-w-4xl mx-auto" data-id="element-350">
            <div className="space-y-6" data-id="element-351">
              <div className="flex items-start gap-4" data-id="element-352">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-red mt-2.5 shrink-0" data-id="element-353"></div>
                <p className="text-lg text-zinc-400" data-id="element-354">
                  No es un tutorial de YouTube que no explica nada.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-355">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-red mt-2.5 shrink-0" data-id="element-356"></div>
                <p className="text-lg text-zinc-400" data-id="element-357">
                  No es un manual técnico inaccesible.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-358">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-red mt-2.5 shrink-0" data-id="element-359"></div>
                <p className="text-lg text-zinc-400" data-id="element-360">
                  No es un método pensado para mecánicos profesionales.
                </p>
              </div>
            </div>

            <div className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800" data-id="element-361">
              <p className="text-2xl text-white font-bold leading-tight" data-id="element-362">
                Es tu protocolo de reparación.
                <br data-id="element-363" />
                <span className="text-brand-cyan" data-id="element-364">Tu sistema.</span>
                <br data-id="element-365" />
                Tu independencia del service.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}